<script setup lang="ts">
import { ref } from 'vue'
import { Lock, Eye, EyeClosed } from '@lucide/vue'

interface InputPasswordProps {
  label: string
  placeholder?: string
  autocomplete?: 'on' | 'off'
}

withDefaults(defineProps<InputPasswordProps>(), {
  label: 'Some label',
  placeholder: '',
  autocomplete: 'off',
})

const showPassword = ref(false)
const model = defineModel()
</script>

<template>
  <div>
    <label class="text-sm font-bold text-foreground dark:text-white mb-1.5 inline-block">{{
      label
    }}</label>
    <div class="relative">
      <Lock :size="14" class="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
      <input
        :autocomplete="autocomplete"
        :type="showPassword ? 'text' : 'password'"
        v-model="model"
        :placeholder="placeholder"
        class="w-full h-9 pl-8 pr-3 rounded-lg border border-border bg-background text-sm placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-primary/50 focus:border-primary/50 transition-all dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"
      />
      <span
        @click="showPassword = !showPassword"
        class="absolute z-30 -translate-y-1/2 cursor-pointer right-4 top-1/2"
      >
        <Eye :size="16" v-if="!showPassword" class="text-muted-foreground" />
        <EyeClosed :size="16" v-else class="text-muted-foreground" />
      </span>
    </div>
  </div>
</template>
